import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const CheckboxClassName = `${CLASS_NAME_PREFIX}-checkbox`;
export const CheckboxClassNameLabel = `${CheckboxClassName}__label`;
export const CheckboxClassNameSquare = `${CheckboxClassName}__square`;
